const floatRound = (inputNumber: number) => Number(inputNumber.toPrecision(3))

export default floatRound
